import { Component, Prop } from 'vue-property-decorator'
import { VacationerInfo } from './types';
import { IEDate, uGetDateFormat } from '@appbase/util';
import UserCardComponent from '@appbase/components/common/UserCard/UserCardComponent';


@Component({})
export default class VacationerItem extends UserCardComponent {
  //
  // ────────────────────────────────────────────────── I ──────────
  //   :::::: P R O P S : :  :   :    :     :        :          :
  // ────────────────────────────────────────────────────────────
  //
  @Prop({ type: Object }) item!: VacationerInfo;
  @Prop({ type: Boolean }) isLoading!: boolean;

  //
  // ──────────────────────────────────────────────────────── I ──────────
  //   :::::: C O M P U T E D : :  :   :    :     :        :          :
  // ──────────────────────────────────────────────────────────────────
  //
  get status() {
    const { startDateAMPM, isHalfDay, isHalfHalfDay, leaveTypeName } = this.item;

    let strType = leaveTypeName;
    let strAmpm = startDateAMPM == 'AM' ? `(${this.$t('오전').toString()})` : `(${this.$t('오후').toString()})`;

    if (isHalfHalfDay == 'Y') {
      strType = this.$t('반반차').toString();
      strType += strAmpm;
    }

    if (isHalfDay == 'Y') {
      strType = this.$t('반차').toString();
      strType += strAmpm;
    }

    return strType;
  }

  convertedDate(date: Date) {
    return uGetDateFormat('MM.DD', IEDate(date));
  }
}